import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceService } from './../../../shared/services/service.service';
import { GetPickForServiceCarListResponse } from './../../../shared/models/service.models';
import { ActiveUserLocalDataService } from './../../../shared/services/active-user-local-data.service';

@Component({
  templateUrl: 'service-pick-car.component.html',
  styleUrls: ['./service-pick-car.component.scss']
})
export class ServicePickCarComponent implements OnInit {

  carListResponse: GetPickForServiceCarListResponse | null = null;
  loading: boolean = true;
  flag: boolean = true;

  constructor(
    private serviceService: ServiceService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadCarList();
  }

  loadCarList() {
    this.loading = true;
    this.serviceService.getPickForServiceCarList().subscribe(
      (response: GetPickForServiceCarListResponse) => {
        this.carListResponse = response;
        this.loading = false;
      },
      (error) => {
        console.error('Error fetching car list:', error);
        this.loading = false;
      }
    );
  }

  continueNextStep(carId: number, carNumber: string, activeServiceVoucherId: number | null) {
  
    if (activeServiceVoucherId !== null) {
      this.activeUserLocalDataService.activeServiceVoucherId = activeServiceVoucherId;
      this.activeUserLocalDataService.activeServiceCarNumber = carNumber;
      this.router.navigate(['/service-voucher']);
    } else {
      this.activeUserLocalDataService.newServiceVoucherCarId = carId;
      this.activeUserLocalDataService.activeServiceVoucher = null;
      this.activeUserLocalDataService.activeServiceVoucherId = undefined;
      this.activeUserLocalDataService.activeServiceCarNumber = carNumber;
      this.activeUserLocalDataService.newServiceVoucherComments = [];
      this.router.navigate(['/service-voucher-start-add-comments']);
    }
  }

  navigateToService() {
    this.router.navigate(['/service-voucher']);
  }

  onContentReady(e: any) {
    if (this.flag) {
      e.component.expandItem(0);
      e.component.expandItem(1);
      this.flag = false;
    }
  }
}